import React, {Component} from 'react'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import Controls from './Controls'
import Table from './Table'

@withBoundary
class Screener extends Component {
  render() {
    return(
      <div>
        <DocumentTitle title='Stock filter manager'/>
        <Controls/>
        <div className="v-space"></div>
        <Table/>
      </div>
    )
  }
}

export default Screener
